// Only persistence in Bloomreach — widget_state returns verbatim on next app_hello.
export const MAX_BYTES = 4096;

export function toWidgetState(draft, phoneAttribute) {
  return {
    v: 1,
    channelId: draft.channelId,
    templateId: draft.templateId,
    headerParams: draft.headerParams || [],
    params: draft.params || [],
    mediaUrl: draft.mediaUrl || null,
    fileName: draft.fileName || null,
    location: draft.location || null,
    buttonUrlParam: draft.buttonUrlParam || null,
    ctaButtonUrl: draft.ctaButtonUrl || null,
    waTemplateJson: draft.waTemplateJson || null,
    isTemplate: typeof draft.isTemplate === 'boolean' ? draft.isTemplate : null,
    messageType: draft.messageType || null,
    destination: draft.destination || null,
    // '' is kept as is: an emptied field is general consent on purpose, while null means never saved (the org's applies).
    consentCategory: typeof draft.consentCategory === 'string' ? draft.consentCategory : null,
    phoneAttribute,
  };
}

export function byteLength(obj) {
  return new TextEncoder().encode(JSON.stringify(obj)).length;
}

export function fromWidgetState(obj) {
  if (!obj || obj.v !== 1) return null;
  return {
    channelId: obj.channelId,
    templateId: obj.templateId,
    headerParams: obj.headerParams || [],
    params: obj.params || [],
    mediaUrl: obj.mediaUrl || null,
    fileName: obj.fileName || null,
    location: obj.location || null,
    buttonUrlParam: obj.buttonUrlParam || null,
    ctaButtonUrl: obj.ctaButtonUrl || null,
    waTemplateJson: obj.waTemplateJson || null,
    isTemplate: typeof obj.isTemplate === 'boolean' ? obj.isTemplate : undefined,
    messageType: obj.messageType || null,
    // Shape only; normalizeDestination validates it (state saved before this field is null).
    destination: obj.destination && typeof obj.destination === 'object'
      ? { type: obj.destination.type, value: obj.destination.value }
      : null,
    // null when never saved (state from before this field); '' is a real value, see toWidgetState.
    consentCategory: typeof obj.consentCategory === 'string' ? obj.consentCategory : null,
  };
}
